export default {"src":"/_next/static/media/apply-icon.ad20f1bc.svg","height":172,"width":133,"blurWidth":0,"blurHeight":0};